import deliveryNoteLogo from '../Logos/Priballl.png';

const COMPANY = {
  name: 'Priball - Balones deportivos',
  tagline: 'Fabrica de balones deportivos',
  address: 'Ruta 9 y Junin, Bell Ville, Cba.',
  phone: '(3537)302888',
  city: 'Bell Ville',
  postalCode: '2550',
  province: 'Cordoba',
  country: 'Argentina',
  website: 'www.priball.com'
};

const getDeliveryNoteLogoUrl = () => {
  if (!deliveryNoteLogo) return '';
  return typeof deliveryNoteLogo === 'string' && deliveryNoteLogo.startsWith('http')
    ? deliveryNoteLogo
    : `${window.location.origin}${deliveryNoteLogo}`;
};

const escapeHtml = (value) => {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

const field = (label, value, className = '') => `
  <div class="label-field ${className}">
    <span>${escapeHtml(label)}</span>
    <strong>${escapeHtml(value)}</strong>
  </div>`;

const renderLabel = (order, logoUrl, size = 'large') => `
  <article class="shipping-label ${size === 'small' ? 'small-label' : 'large-label'}">
    <header class="brand-header">
      <img src="${logoUrl}" alt="Priball Logo" class="brand-logo" />
      <div class="sender-card">
        <span class="eyebrow">Remitente</span>
        <h1>${escapeHtml(COMPANY.name)}</h1>
        <p>${escapeHtml(COMPANY.address)} · ${escapeHtml(COMPANY.city)} (${escapeHtml(COMPANY.postalCode)})</p>
        <p>Tel. ${escapeHtml(COMPANY.phone)} · ${escapeHtml(COMPANY.website)}</p>
      </div>
    </header>

    <section class="recipient-card">
      <span class="eyebrow">Destinatario</span>
      <h2>${escapeHtml(order.nombre || '')}</h2>
      <p class="address-line">${escapeHtml(order.domicilio || '')}</p>
      <div class="recipient-grid">
        ${field('Localidad', order.localidad || '')}
        ${field('Codigo postal', order.codigoPostal || '')}
        ${field('Provincia', order.provincia || '')}
        ${field('Pais', order.pais || 'Argentina')}
        ${field('Telefono', order.telefono || '', 'span-2')}
      </div>
      ${order.informacionAdicional ? `<p class="notes"><strong>Info adicional:</strong> ${escapeHtml(order.informacionAdicional)}</p>` : ''}
    </section>
  </article>`;

export const printShippingLabel = (order, { onPopupBlocked } = {}) => {
  const logoUrl = getDeliveryNoteLogoUrl();
  const smallLabels = Array.from({ length: 6 }, () => renderLabel(order, logoUrl, 'small')).join('');

  const bodyHtml = `
    <div class="print-controls" role="dialog" aria-label="Elegir formato de rótulo">
      <div>
        <strong>Elegí el formato del rótulo</strong>
        <p>El formato seleccionado se enviará al diálogo de impresión.</p>
      </div>
      <div class="print-control-actions">
        <button type="button" data-print-layout="large">Imprimir A4 grande</button>
        <button type="button" data-print-layout="six">Imprimir 6 por hoja</button>
      </div>
    </div>

    <main class="shipping-document">
      <section class="label-page shipping-page layout-large">
        ${renderLabel(order, logoUrl, 'large')}
      </section>

      <section class="label-page six-label-page layout-six">
        ${smallLabels}
      </section>
    </main>`;

  const criticalCss = `
*{box-sizing:border-box}
html,body{margin:0;padding:0;background:#f5f7fb;color:#111827;font-family:Arial,Helvetica,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact}
body{padding:88px 0 24px}
.print-controls{position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:10;width:min(720px,calc(100vw - 32px));display:flex;align-items:center;justify-content:space-between;gap:18px;padding:14px 16px;border:1px solid #cbd5e1;border-radius:18px;background:#fff;box-shadow:0 18px 45px rgba(15,23,42,.18)}
.print-controls strong{display:block;margin-bottom:3px;font-size:15px;color:#0f172a}
.print-controls p{margin:0;color:#64748b;font-size:12px}
.print-control-actions{display:flex;gap:10px;flex-wrap:wrap;justify-content:flex-end}
.print-control-actions button{border:none;border-radius:999px;padding:11px 15px;background:#0f172a;color:#fff;font-size:13px;font-weight:800;cursor:pointer}
.print-control-actions button:hover{background:#1e293b}
.shipping-document{width:100%;max-width:210mm;margin:0 auto;background:#fff}
.label-page{min-height:297mm;padding:14mm;background:#fff;page-break-after:always}
.layout-six{display:none}
body[data-layout="six"] .layout-large{display:none}
body[data-layout="six"] .layout-six{display:grid}
.brand-header{display:grid;grid-template-columns:255px 1fr;gap:18px;align-items:center;padding:16px;margin-bottom:18px;border:2px solid #111827;border-radius:22px;background:linear-gradient(135deg,#ffffff 0%,#f3f7fb 100%)}
.brand-logo{width:100%;max-height:129px;object-fit:contain}
.sender-card{text-align:right}
.eyebrow{display:inline-block;margin-bottom:6px;color:#475569;font-size:11px;font-weight:800;letter-spacing:.12em;text-transform:uppercase}
.sender-card h1{margin:0 0 6px;font-size:22px;line-height:1.1;color:#0f172a}
.sender-card p{margin:3px 0;color:#334155;font-size:12px;line-height:1.35}
.label-field{min-height:58px;padding:10px 12px;border:1px solid #cbd5e1;border-radius:12px;background:#fff}
.label-field span{display:block;margin-bottom:5px;color:#64748b;font-size:10px;font-weight:800;letter-spacing:.08em;text-transform:uppercase}
.label-field strong{display:block;color:#111827;font-size:15px;line-height:1.3;word-break:break-word}
.label-field.highlight{border-width:2px;border-color:#111827;background:#f8fafc}
.label-field.highlight strong{font-size:20px}
.span-2{grid-column:1 / -1}
.shipping-page{display:flex;align-items:center;justify-content:center}
.shipping-label{width:100%;min-height:170mm;padding:18px;border:4px solid #0f172a;border-radius:26px;background:#fff}
.recipient-card{margin-top:18px;padding:24px;border:2px dashed #334155;border-radius:20px;background:#f8fafc}
.recipient-card h2{margin:0 0 12px;font-size:34px;line-height:1.05;color:#0f172a;text-transform:uppercase}
.address-line{margin:0 0 18px;padding:14px 16px;border-radius:14px;background:#fff;border:1px solid #cbd5e1;font-size:24px;font-weight:800;line-height:1.2;color:#111827}
.recipient-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.notes{margin:14px 0 0;padding:12px 14px;border-radius:12px;background:#fff;border:1px solid #cbd5e1;font-size:13px;color:#334155}
.six-label-page{grid-template-columns:1fr 1fr;grid-auto-rows:max-content;gap:2mm 3mm;align-content:start;padding:6mm}
.small-label{min-height:0;height:auto;padding:6px;border-width:2px;border-radius:14px;overflow:hidden}
.small-label .brand-header{grid-template-columns:108px 1fr;gap:6px;margin-bottom:6px;padding:6px;border-width:1px;border-radius:10px}
.small-label .brand-logo{max-height:51px}
.small-label .sender-card h1{font-size:11px;margin-bottom:1px}
.small-label .sender-card p{font-size:7px;line-height:1.15;margin:1px 0}
.small-label .eyebrow{font-size:7px;margin-bottom:2px;letter-spacing:.08em}
.small-label .recipient-card{margin-top:6px;padding:7px;border-width:1px;border-radius:10px}
.small-label .recipient-card h2{font-size:15px;margin-bottom:5px}
.small-label .address-line{margin-bottom:6px;padding:6px 7px;border-radius:8px;font-size:12px}
.small-label .recipient-grid{gap:4px}
.small-label .label-field{min-height:30px;padding:4px 5px;border-radius:7px}
.small-label .label-field span{font-size:7px;margin-bottom:2px;letter-spacing:.06em}
.small-label .label-field strong{font-size:9px;line-height:1.1}
.small-label .notes{margin-top:5px;padding:5px 6px;border-radius:7px;font-size:8px}
@media print{
  @page{size:A4;margin:0}
  html,body{width:210mm;min-height:297mm;background:#fff}
  body{padding:0}
  .print-controls{display:none!important}
  .shipping-document{max-width:none}
  .label-page{min-height:297mm;padding:12mm}
  .shipping-label{min-height:170mm}
  .layout-large{display:flex}
  .layout-six{display:none}
  body[data-layout="six"] .layout-large{display:none!important}
  body[data-layout="six"] .layout-six{display:grid!important}
  body[data-layout="six"] .label-page{padding:6mm}
  body[data-layout="six"] .six-label-page{height:297mm;min-height:297mm;max-height:297mm;grid-auto-rows:max-content;align-content:start;gap:2mm 3mm;page-break-after:auto;overflow:hidden}
  body[data-layout="six"] .shipping-label{min-height:0!important}
  body[data-layout="six"] .small-label{height:auto;min-height:0!important;break-inside:avoid;page-break-inside:avoid}
}
`;

  const win = window.open('', '_blank');
  if (!win) {
    if (typeof onPopupBlocked === 'function') onPopupBlocked();
    return false;
  }

  win.document.write(
    `<!DOCTYPE html><html><head><meta charset="utf-8" /><title>Rótulo</title><style>${criticalCss}</style></head><body data-layout="large">${bodyHtml}<script>
      (function () {
        function printLayout(layout) {
          document.body.dataset.layout = layout;
          setTimeout(function () {
            window.focus();
            window.print();
          }, 150);
        }
        document.querySelectorAll('[data-print-layout]').forEach(function (button) {
          button.addEventListener('click', function () {
            printLayout(button.getAttribute('data-print-layout'));
          });
        });
      }());
    </script></body></html>`
  );
  win.document.close();

  const waitThenPrint = () => {
    if (win.document.readyState !== 'complete') {
      win.onload = waitThenPrint;
      return;
    }

    const images = win.document.querySelectorAll('img');
    const pending = Array.from(images).filter((img) => !img.complete);
    if (pending.length === 0) {
      return;
    }

    let waited = 0;
    const check = () => {
      if (Array.from(images).every((img) => img.complete) || waited >= 5000) {
        return;
      }
      waited += 200;
      setTimeout(check, 200);
    };
    setTimeout(check, 200);
  };

  win.onload = waitThenPrint;
  setTimeout(waitThenPrint, 1200);
  return true;
};
